import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { format, isSameDay } from "date-fns";

interface DaysHeaderProps {
    weekDates: Date[];
    today?: Date;
    theme: any;
}

const DaysHeader: React.FC<DaysHeaderProps> = ({ weekDates, today = new Date(), theme }) => (
    <Box sx={{ display: "flex", mb: 2, gap: 1 }}>
        <Box sx={{ flex: "0 0 120px" }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, textAlign: "center", p: 1 }}>
                Time
            </Typography>
        </Box>
        {weekDates.map((date, index) => (
            <Box key={index} sx={{ flex: 1 }}>
                <Paper
                    elevation={1}
                    sx={{
                        p: 1,
                        textAlign: "center",
                        background: isSameDay(date, today) ? theme.palette.secondary.main : theme.palette.background.paper,
                        color: isSameDay(date, today) ? theme.palette.secondary.contrastText : "inherit",
                        borderRadius: 2,
                    }}
                >
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        {format(date, "EEE")}
                    </Typography>
                    <Typography variant="body2">{format(date, "dd")}</Typography>
                </Paper>
            </Box>
        ))}
    </Box>
);

export default DaysHeader;
